const LOGOS = ["Forbes", "WIRED", "Vogue", "Bloomberg", "TechCrunch", "GQ", "WSJ", "Men's Health"];

export const Marquee = () => {
  return (
    <section aria-label="Press" className="border-y border-border/70 bg-background/40">
      <div className="container-wide py-8 overflow-hidden">
        <p className="text-[11px] uppercase tracking-[0.2em] text-foreground/70 text-center mb-5">
          As featured in
        </p>
        <span className="sr-only">As featured in: {LOGOS.join(", ")}.</span>
        <div aria-hidden="true" className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
          <div className="flex gap-16 animate-marquee whitespace-nowrap w-max motion-reduce:animate-none">
            {[...LOGOS, ...LOGOS].map((logo, i) => (
              <span
                key={i}
                className="font-display text-2xl text-foreground/40 tracking-tight"
              >
                {logo}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
